const apiRoute = {
    student : '/api/students',
    attendance : '/api/attendance',
    mail : '/api/mail',
    statement : '/api/statement',
    img : '/imgs',
}

export default apiRoute;
